<div class="bg-secondary">
    <main>
        <div class="container">
            <!--Grid row-->

            <div class="row1 pt-3">

                <b-card>
                    <b-form-group label-cols-lg="12" label="Select" label-size="lg"
                        label-class="font-weight-bold pt-0" class="mb-0">
                        <div class="row row-grid">
                            <div class="col-lg-3 col-mb-3 pt-3" v-for="(item, index) in countries" :key="index">
                                <router-link :to="proceed(item.id)">
                                    <b-card class="border-1 text-center" border-variant="dark" hover>
                                        <img v-if="item.img" :src="item.img" height="50px" :alt="item.name" />
                                        <h6 class="text-uppercase">
                                            {{ item.name }}
                                        </h6>
                                    </b-card>
                                </router-link>
                            </div>
                        </div>
                    </b-form-group>
                </b-card>
            </div>
            <!--Grid row-->
            <p>&nbsp;</p>
        </div>
    </main>
    <!--Main layout-->
</div>